import React, { ReactElement } from 'react';
import SuccessIcon from '../../icons/success-icon';
import FormatService from '../../services/format-service';
import useStylesIconBlockSuccess from './icon-block-success.styles';

const IconBlockSuccess: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    className,
  } = props;

  const { classes } = useStylesIconBlockSuccess();

  return (
    <SuccessIcon className={FormatService.formatClassNames(classes.iconBlockSuccess, className)} />
  );
});

export default IconBlockSuccess;
